import {
  Box,
  CircularProgress,
  Checkbox,
  Typography,
  IconButton,
  FormControl,
  Autocomplete,
  FormControlLabel,
  Tooltip,
  TextField,
  Select,
  MenuItem,
  Chip,
  Button,
  InputAdornment,
  Dialog,
  ListItemText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useHistory, useLocation } from "react-router-dom";
import {
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "../../mui";

import React, { useState, useEffect } from "react";
import UIWrapper from "../../components/UIWrapper";
import ShipmentInquiriesService from "../../services/ShipmentInquiriesService";
import { snackbarActions } from "../../Store/snackbar";
import { useDispatch } from "react-redux";
import ShipmentRequestConfirmationDialog from "./ShipmentRequestConfirmationDialog";
import AccService from "../../services/AccService";
import AcsService from "../../services/AcsService";
import BiService from "../../services/BiService";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.selectedNavItemHover?.bgColor || "#f5f5f5",
    color: theme.palette.selectedNavItem?.color || "#000",
    fontWeight: "bold",
  },
}));

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  fontSize: "13px",
  outline: "none",
  color: "#000",

  "::placeholder": {
    color: "#9ca3af",
    opacity: 1,
  },
};

const labelStyle = {
  fontSize: "12px",
  color: "#666",
  marginBottom: "4px",

  color: "#374151",
  fontWeight: 500,
};


const draftBtn = {
  padding: "6px 14px",
  border: "1px solid #ccc",
  background: "#f5f5f5",
  cursor: "pointer",
  borderRadius: "6px",
};

const submitBtn = {
  padding: "6px 16px",
  background: "#1976d2",
  color: "#fff",
  border: "none",
  cursor: "pointer",
  borderRadius: "6px",
  fontWeight: 500,
};

const getStatusChip = (status) => {
  const map = {
    stored: { color: "#1e88e5", bg: "#e3f2fd" },
    shipped: { color: "#7c3aed", bg: "#ede9fe" },
    disposed: { color: "#f59e0b", bg: "#fff7ed" },
    completed: { color: "#2e7d32", bg: "#e8f5e9" },
    rejected: { color: "#c73e08", bg: "#e8f5e9" },
  };

  const key = status?.toLowerCase();
  const item = map[key] || { color: "#1976d2", bg: "#e3f2fd" };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        px: "10px",
        py: "4px",
        borderRadius: "999px",
        backgroundColor: item.bg,
        width: "fit-content",
      }}
    >
      <Box
        sx={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: item.color,
        }}
      />
      <Typography
        sx={{
          fontSize: "12px",
          color: item.color,
          fontWeight: 500,
        }}
      >
        {status}
      </Typography>
    </Box>
  );
};

const filterWidth = {
  xs: "100%",
  sm: "130px",
};


const inquiryTableColumns = [
  "Inventory Code",
  "Sample Type",
  "Container",
  "Volume",
  "Site",
  "Status",
  "Service Status",
  "Collected",
];

const carrierTypes = [
  {
    value: "BIOCAIR",
    label: "BIOCAIR",
  },
  {
    value: "DHL",
    label: "DHL",
  },
  {
    value: "FedEx",
    label: "FedEx",
  },
  {
    value: "FedEx Ground",
    label: "FedEx Ground",
  },
  {
    value: "Hand Delivered",
    label: "Hand Delivered",
  },
  {
    value: "Marken",
    label: "Marken",
  },
  {
    value: "Priority Express",
    label: "Priority Express",
  },
  {
    value: "Quickstat",
    label: "Quickstat",
  },
  {
    value: "TNT",
    label: "TNT",
  },
  {
    value: "UPS",
    label: "UPS",
  },
  {
    value: "USA Courier",
    label: "USA Courier",
  },
  {
    value: "USPS",
    label: "USPS",
  },
  {
    value: "VIP Cargo",
    label: "VIP Cargo",
  },
  {
    value: "World Courrier",
    label: "World Courrier",
  },
];

const ShipmentRequest = () => {
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useState({
    search: "",
    sample_type: [],
    status: "",
    site: "",
  });
  const [rowsPerPageLarge, setRowsPerPageLarge] = useState(10);
  const [pageLarge, setPageLarge] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [carrier, setCarrier] = useState("");
  const [temperatureOptions, setTemperatureOptions] = useState([]);
  const [apiSites, setApiSites] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [clientState, setClientState] = useState("");
  const [projectState, setProjectState] = useState("");
  const [projectOptions, setProjectOptions] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [shipDate, setShipDate] = useState("");
  const [shipTime, setShipTime] = useState("");
  const [destinationSite, setDestinationSite] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [temperature, setTemperature] = useState("");
  const [specialInstruction, setSpecialInstruction] = useState("");
  const [sourceList, setSourceList] = useState([]);
  const [containerList, setContainerList] = useState([]);
  const [actionType, setActionType] = useState("Pending");
  const [sampleView, setSampleView] = useState("available");
  const [requestInventoryCodes, setRequestInventoryCodes] = useState([]);
  const [selectedMappings, setSelectedMappings] = useState([]);
  const [draftClients, setDraftClients] = useState([]);
  const [draftProjects, setDraftProjects] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get("request_id");
  const isEditMode = !!requestId;
  const history = useHistory();

  useEffect(() => {
    AcsService.getSources()
      .then((resp) => {
        setSourceList(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    BiService.getContainers()
      .then((resp) => {
        setContainerList(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getTableData = () => {
    setLoading(true);

    const params = {};
    
    if (sampleView === "all") {
      params.is_all_samples = true;
    }

    if (filters.sample_type.length > 0) {
      params.sample_type = filters.sample_type;
    }

    if (sampleView === "available") {
      params.status = "Stored";
    } else {
      if (filters.status) {
        params.status = filters.status;
      }
    }

    if (filters.container) {
      params.container_type = filters.container;
    }

    if (filters.site) {
      params.site = filters.site;
    }

    if (debouncedSearch) {
      params.inventory_code = debouncedSearch;
    }

    if (clientState) params.client = clientState;
    if (projectState) params.project = projectState;
    if (requestId) params.request_id = requestId;

    ShipmentInquiriesService.getInventoryDataTest(
      params,
      pageLarge + 1,
      rowsPerPageLarge,
    )
      .then((resp) => {
        const responseData = resp?.data || {};

        setTableData(responseData.data || []);
        setTotalCount(responseData.total || 0);

        const requestData = responseData.sample_request_data?.[0];

        if (requestData && requestInventoryCodes.length === 0) {
          const requestCodes = requestData.inventory_code || [];
          setRequestInventoryCodes(requestCodes);
          setDraftClients(requestData.client || []);
          setDraftProjects(requestData.project || []);
          setCarrier(requestData.carrier || "");
          setShipDate(requestData.ship_date || "");
          setShipTime(requestData.ship_time || "");
          setDestinationSite(requestData.destination_site || "");
          setShippingAddress(requestData.shipping_address || "");
          setTemperature(requestData.temprature || "");
          setSpecialInstruction(requestData.special_instruction || "");
        }

        if (responseData.client) {
          setClientState(responseData.client);
          getProjectList(responseData.client);
        }

        if (responseData.project) {
          setProjectState(responseData.project);
        }
      })
      .catch((err) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: err.message,
          }),
        );
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const matchedRows = tableData.filter((row) =>
      requestInventoryCodes.includes(row.inventory_code),
    );

    setSelectedRows(matchedRows);
  }, [tableData, requestInventoryCodes]);

  useEffect(() => {
    if (clientState && projectState) {
      ShipmentInquiriesService.getTemperatureAndSites(clientState, projectState)
        .then((resp) => {
          setApiSites(resp.data.sites || []);
          setTemperatureOptions(resp.data.temperatures || []);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [clientState, projectState]);

  const handleClientChange = (event, newValue) => {
    setClientState(newValue);
    setProjectState("");
    if (newValue) {
      getProjectList(newValue);
    } else {
      setProjectOptions();
    }
  };

  const handleProjectChange = (event, newValue) => {
    setProjectState(newValue);
  };

  const getProjectList = (clientName) => {
    if (clientName) {
      AccService.getClientProjects(clientName)
        .then((resp) => setProjectOptions(resp.data))
        .catch(() => setProjectOptions());
    }
  };

  useEffect(() => {
    AccService.getAllClients("").then((resp) => setClientOptions(resp.data));
  }, []);

  useEffect(() => {
    getTableData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(filters.search);
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [filters.search]);

  useEffect(() => {
    getTableData();
  }, [
    debouncedSearch,
    filters.status,
    filters.sample_type,
    filters.container,
    filters.site,
    requestId,
    sampleView,
    pageLarge,
    rowsPerPageLarge,
  ]);

  const handleSelectRow = (row) => {
    const exists = requestInventoryCodes.includes(row.inventory_code);

    if (exists) {
      setRequestInventoryCodes((prev) =>
        prev.filter((code) => code !== row.inventory_code)
      );

      setSelectedMappings((prev) =>
        prev.filter(
          (item) => item.inventory_code !== row.inventory_code
        )
      );
    } else {
      setRequestInventoryCodes((prev) => [
        ...prev,
        row.inventory_code,
      ]);

      setSelectedMappings((prev) => [
        ...prev,
        {
          inventory_code: row.inventory_code,
          client: clientState,
          project: projectState,
        },
      ]);
    }
  };

  const handleRemove = (id) => {
    setRequestInventoryCodes((prev) => prev.filter((code) => code !== id));

    setSelectedMappings((prev) =>
      prev.filter((item) => item.inventory_code !== id)
    );

  };

  const handleClearAll = () => {
    setRequestInventoryCodes([]);
    setSelectedRows([]);
    setSelectedMappings([])
  };

  const commonDispatch = (type, message) => {
    dispatch(
      snackbarActions.showNotification({
        snackbarOpen: true,
        snackbarType: type,
        snackbarMessage: message,
      }),
    );
  };

  const handleSetDefault = () => {
    const payload = {
      client: clientState,
      project: projectState,
    };
    ShipmentInquiriesService.setDefault(payload)
      .then((resp) => {
        commonDispatch("success", resp.data);
        setRequestInventoryCodes([]);
        setSelectedRows([]);
        setSelectedMappings([])
        setShowConfirmModal(false);
        getTableData();
      })
      .catch((err) => {
        commonDispatch(
          "warning",
          err?.response?.data?.detail || "Action failed",
        );
        setShowConfirmModal(false);
      });
  };

  const handleSaveDraft = () => {
    const payload = {
      request_id: requestId,
      inventory_codes: requestInventoryCodes,
      client: selectedClients,
      project: selectedProjects,
      ship_date: shipDate,
      ship_time: shipTime,
      status: "Draft",
      carrier: carrier,
      temprature: temperature,
      destination_site: destinationSite,
      shipping_address: shippingAddress,
      special_instruction: specialInstruction || "NA",
    };

    const apiCall = requestId
      ? ShipmentInquiriesService.updateShipmentRequest
      : ShipmentInquiriesService.submitNewShipment;

    apiCall(payload)
      .then(() => {
        commonDispatch("success", requestId ? "Draft updated" : "Draft saved");
        history.push("/sample-distribution/shipment_request");
      })
      .catch((err) => {
        commonDispatch(
          "error",
          err?.response?.data?.message || "Failed to save draft",
        );
      });
  };

  const hiddenSelectedCodes = requestInventoryCodes.filter(
    (code) => !tableData.some((row) => row.inventory_code === code),
  );

  const selectedClients =
    selectedMappings.length > 0
      ? [...new Set(selectedMappings.map((item) => item.client))]
      : draftClients;

  const selectedProjects =
    selectedMappings.length > 0
      ? [...new Set(selectedMappings.map((item) => item.project))]
      : draftProjects;

  const isFormValid =
    destinationSite.trim() !== "" &&
    shippingAddress.trim() !== "" &&
    shipDate !== "" &&
    shipTime !== "" &&
    carrier !== "" &&
    temperature.trim() !== "" &&
    requestInventoryCodes.length > 0;

  return (
    <UIWrapper title="Request Sample Shipment" paper>
      <Box>
        <Box>

          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: {
                xs: "flex-start",
                md: "center",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "20px" }}>
                Available Samples
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Tooltip title="Set default selected client and project(s)">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showConfirmModal}
                      name="Set Default"
                      onChange={() => setShowConfirmModal(true)}
                    />
                  }
                  label="Set Default"
                  disabled={!projectState || isEditMode}
                />
              </Tooltip>

              <FormControl
                size="small"
                sx={{ minWidth: "145px", maxWidth: "145px" }}
              >
                <Autocomplete
                  disabled={isEditMode}
                  id="free-solo-demo"
                  freeSolo
                  size="small"
                  margin="dense"
                  value={clientState || null}
                  options={clientOptions}
                  onChange={handleClientChange}
                  renderInput={(params) => (
                    <TextField
                      margin="dense"
                      {...params}
                      id="standard-multiline-flexible"
                      size="small"
                      type="text"
                      name={"Client"}
                      label={"Client"}
                      sx={{ margin: "0px" }}
                    />
                  )}
                />
              </FormControl>

              <FormControl
                size="small"
                sx={{ minWidth: "145px", maxWidth: "145px" }}
              >
                <Autocomplete
                  disabled={isEditMode}
                  id="free-solo-demo"
                  freeSolo
                  size="small"
                  margin="dense"
                  options={projectOptions}
                  value={projectState || null}
                  onChange={handleProjectChange}
                  renderInput={(params) => (
                    <TextField
                      margin="dense"
                      {...params}
                      id="standard-multiline-flexible"
                      size="small"
                      type="text"
                      name={"Project"}
                      label={"Project"}
                      sx={{ margin: "0px" }}
                    />
                  )}
                />
              </FormControl>
            </Box>
          </Stack>
        </Box>

        <Stack
          direction={{ xs: "column", lg: "row" }}
          spacing={2}
          mt={2}
        >

          <Box
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                mb: 2,
                background: "#fff",
              }}
            >

              <Stack
                direction={{ xs: "column", xl: "row" }}
                spacing={2}
                sx={{
                  px: 2,
                  py: 1.5,
                  alignItems: {
                    xs: "stretch",
                    xl: "center",
                  },
                  justifyContent: "space-between",
                }}
              >

                <Stack
                  direction="row"
                  sx={{
                    flexWrap: "wrap",
                    gap: 1.5,
                    width: "100%",
                  }}
                >
                  <TextField
                    size="small"
                    placeholder="Search Inventory Code"
                    value={filters.search}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        search: e.target.value,
                      }))
                    }
                    sx={{
                      minWidth: 180,
                      "& .MuiInputBase-input": {
                        color: "rgba(0, 0, 0, 0.87)",
                        fontWeight: 400,
                        WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
                      },

                      "& input::placeholder": {
                        color: "rgba(0, 0, 0, 0.6)",
                        opacity: 1,
                      },

                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#ccc",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Autocomplete
                    size="small"
                    options={["All Containers", ...containerList]}
                    value={filters.container || "All Containers"}
                    onChange={(event, newValue) => {
                      setFilters((prev) => ({
                        ...prev,
                        container:
                          newValue === "All Containers" ? "" : newValue,
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder="Select Container"
                      />
                    )}
                    sx={{
                      width: 180,
                    }}
                    clearOnEscape
                    fullWidth={false}
                    noOptionsText="No containers found"
                  />

                  <Autocomplete
                    multiple
                    size="small"
                    options={sourceList}
                    value={filters.sample_type}
                    disableCloseOnSelect
                    disableClearable
                    onChange={(event, newValue) => {
                      setFilters((prev) => ({
                        ...prev,
                        sample_type: newValue,
                      }));
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                        <ListItemText primary={option} />
                      </li>
                    )}
                    renderTags={() => null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label="Sample Type"
                      />
                    )}
                    sx={{
                      width: filterWidth,
                      maxWidth: 200,
                      "& .MuiInputBase-root": {
                        height: "40px",
                        alignItems: "center",
                      },
                      "& .MuiInputBase-input": {
                        color: "#000 !important",
                        fontWeight: 500,
                        WebkitTextFillColor: "#000 !important",
                      },

                      "& .MuiInputLabel-root": {
                        color: "#444",
                        fontWeight: 500,
                      },

                      "& input::placeholder": {
                        color: "#666",
                        opacity: 1,
                      },
                    }}
                    noOptionsText="No sample types found"
                  />


                  <Select
                    size="small"
                    disabled={sampleView === "available"}
                    value={
                      sampleView === "available"
                        ? "Stored"
                        : (filters.status || "all")
                    }
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        status: e.target.value === "all" ? "" : e.target.value,
                      }))
                    }
                    sx={{
                      width: filterWidth,
                    }}
                  >
                    <MenuItem value="all">All Status</MenuItem>
                    <MenuItem value="Stored">Stored</MenuItem>
                    <MenuItem value="Rejected">Rejected</MenuItem>
                    <MenuItem value="Disposed">Disposed</MenuItem>
                    <MenuItem value="Shipped">Shipped</MenuItem>
                    <MenuItem value="Released">Released</MenuItem>
                  </Select>

                  <Select size="small" defaultValue="all" sx={{
                    width: filterWidth,
                  }}>
                    <MenuItem value="all">Service Status</MenuItem>
                  </Select>

                  <Select

                    sx={{
                      width: filterWidth,
                    }}

                    size="small"
                    value={filters.site || "all"}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        site: e.target.value === "all" ? "" : e.target.value,
                      }))
                    }
                  >
                    <MenuItem value="all">All Sites</MenuItem>

                    {apiSites.map((site, index) => (
                      <MenuItem key={index} value={site}>
                        {site}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    background: "#eef2f7",
                    borderRadius: "999px",
                    p: "2px",
                    height: "34px",
                    flexShrink: 0,
                  }}
                >
                  <Button
                    onClick={() => setSampleView("available")}
                    disableRipple
                    sx={{
                      px: 2.5,
                      height: "30px",
                      borderRadius: "999px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "14.5px",
                      letterSpacing: "0.5px",
                      minWidth: "140px",

                      backgroundColor:
                        sampleView === "available" ? "#1976d2" : "transparent",

                      color: sampleView === "available" ? "#fff" : "#5f6b7a",

                      boxShadow:
                        sampleView === "available"
                          ? "0px 1px 3px rgba(0,0,0,0.2)"
                          : "none",

                      "&:hover": {
                        backgroundColor:
                          sampleView === "available"
                            ? "#1565c0"
                            : "transparent",
                      },
                    }}
                  >
                    Available Samples
                  </Button>

                  <Button
                    onClick={() => setSampleView("all")}
                    disableRipple
                    sx={{
                      px: 2.5,
                      height: "30px",
                      borderRadius: "999px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "14.5px",
                      letterSpacing: "0.5px",
                      minWidth: "120px",

                      backgroundColor:
                        sampleView === "all" ? "#1976d2" : "transparent",

                      color: sampleView === "all" ? "#fff" : "#5f6b7a",

                      boxShadow:
                        sampleView === "all"
                          ? "0px 1px 3px rgba(0,0,0,0.2)"
                          : "none",

                      "&:hover": {
                        backgroundColor:
                          sampleView === "all" ? "#1565c0" : "transparent",
                      },
                    }}
                  >
                    All Samples
                  </Button>
                </Box>
              </Stack>

              <Box
                sx={{
                  px: 2,
                  pb: 1.5,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {filters.status && (
                    <Chip
                      label={`Status: ${filters.status}`}
                      size="small"
                      onDelete={() =>
                        setFilters((prev) => ({ ...prev, status: "" }))
                      }
                    />
                  )}

                  {filters.sample_type.map((type) => (
                    <Chip
                      key={type}
                      label={`Type: ${type}`}
                      size="small"
                      onDelete={() =>
                        setFilters((prev) => ({
                          ...prev,
                          sample_type: prev.sample_type.filter(
                            (t) => t !== type,
                          ),
                        }))
                      }
                    />
                  ))}

                  {filters.container && (
                    <Chip
                      label={`Container: ${filters.container}`}
                      size="small"
                      onDelete={() =>
                        setFilters((prev) => ({ ...prev, container: "" }))
                      }
                    />
                  )}

                  {filters.search && (
                    <Chip
                      label={`Search: ${filters.search}`}
                      size="small"
                      onDelete={() =>
                        setFilters((prev) => ({ ...prev, search: "" }))
                      }
                    />
                  )}

                  {filters.site && (
                    <Chip
                      label={`Site: ${filters.site}`}
                      size="small"
                      onDelete={() =>
                        setFilters((prev) => ({ ...prev, site: "" }))
                      }
                    />
                  )}
                </Stack>

                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#1976d2",
                    cursor: "pointer",
                    fontWeight: 500,
                  }}
                  onClick={() =>
                    setFilters({
                      search: "",
                      sample_type: [],
                      status: "",
                      site: "",
                    })
                  }
                >
                  Clear all
                </Typography>
              </Box>
            </Box>
            <Box sx={{ mb: 1, textAlign: "end" }}>
              <Typography sx={{ fontSize: "12px", color: "#666" }}>
                Showing{" "}
                {totalCount === 0 ? 0 : pageLarge * rowsPerPageLarge + 1}–
                {Math.min((pageLarge + 1) * rowsPerPageLarge, totalCount)} of{" "}
                {totalCount} samples
              </Typography>
            </Box>

            <TableContainer
              sx={{
                flex: 1,
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "600px",
              }}
            >
              <Table stickyHeader size="small"
                sx={{
                  minWidth: 1000,
                }}
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell />

                    {inquiryTableColumns.map((col, index) => (
                      <StyledTableCell key={index}>{col}</StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : tableData.length > 0 ? (
                    tableData
                      .map((row, index) => {
                        const isSelected = requestInventoryCodes.includes(
                          row.inventory_code,
                        );

                        return (
                          <TableRow
                            key={row.inventory_code}
                            sx={{
                              backgroundColor: isSelected
                                ? "#e3f2fd"
                                : "inherit",
                            }}
                          >
                            <TableCell>
                              <Tooltip
                                title={
                                  sampleView === "all"
                                    ? row.is_associated_with_shipment_request
                                      ? "This sample is already associated with a shipment request"
                                      : row.status !== "Stored"
                                      ? "Only Stored samples can be selected"
                                      : ""
                                    : ""
                                }
                              >
                                <span>
                                  <Checkbox
                                    checked={!!isSelected}
                                    disabled={
                                        sampleView === "all" &&
                                        (
                                          row.status !== "Stored" ||
                                          row.is_associated_with_shipment_request
                                        )
                                      }
                                    onChange={() => handleSelectRow(row)}
                                  />
                                </span>
                              </Tooltip>
                            </TableCell>

                            <TableCell>{row.inventory_code}</TableCell>
                            <TableCell>{row.source}</TableCell>
                            <TableCell>{row.container_type}</TableCell>
                            <TableCell>{row.volume}</TableCell>
                            <TableCell>{row.site}</TableCell>
                            <TableCell>{getStatusChip(row.status)}</TableCell>
                            <TableCell>{row.service_status || ""}</TableCell>
                            <TableCell>{row.draw_date}</TableCell>
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        No Record Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

            
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 15, 25]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPageLarge}
                page={pageLarge}
                onPageChange={(e, newPage) => setPageLarge(newPage)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPageLarge(+e.target.value);
                  setPageLarge(0);
                }}
              />
          </Box>

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: 380,
              },
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                p: 2,
                mb: 2,
                background: "#f9fafb",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography
                    sx={{
                      fontSize: "28px",
                      fontWeight: "bold",
                      color: "#1976d2",
                      lineHeight: 1,
                    }}
                  >
                    {requestInventoryCodes.length}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#666",
                    }}
                  >
                    samples selected
                  </Typography>
                </Stack>
                {requestInventoryCodes.length > 0 && (
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#1976d2",
                      cursor: "pointer",
                      fontWeight: 500,
                    }}
                    onClick={handleClearAll}
                  >
                    Clear all
                  </Typography>
                )}
              </Stack>

              <Divider sx={{ mb: 1 }} />
              {requestInventoryCodes.length > 0 ? (
                  <Box
                    sx={{
                      maxHeight: "220px",
                      overflowY: "auto",
                    }}
                  >
                  {selectedRows.map((row) => (
                    <Box
                      key={row.inventory_code}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        py: 1,
                        px: 1,
                        borderRadius: "6px",
                        "&:hover": { background: "#f1f5f9" },
                      }}
                    >
                      <Stack>
                        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                          {row.inventory_code}
                        </Typography>

                        <Typography sx={{ fontSize: "12px", color: "#888" }}>
                          {row.study || "Sample info"}
                        </Typography>
                      </Stack>
                      <IconButton
                        size="small"
                        onClick={() => handleRemove(row.inventory_code)}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}

                  {hiddenSelectedCodes.map((code) => (
                    <Box
                      key={code}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        py: 1,
                        px: 1,
                        borderRadius: "6px",
                        background: "#fff4e5",
                      }}
                    >
                      <Typography sx={{ fontSize: "14px" }}>{code}</Typography>

                      <IconButton
                        size="small"
                        onClick={() => handleRemove(code)}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#999",
                    textAlign: "center",
                    py: 2,
                  }}
                >
                  No samples selected
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                overflow: "hidden",
                background: "#ffffff",
              }}
            >
              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  borderBottom: "1px solid #eee",
                  background: "#fafafa",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontWeight: 600 }}>
                  Shipment Details
                </Typography>

                <Typography sx={{ fontSize: "12px", color: "#999" }}>
                  Required
                </Typography>
              </Box>

              <Stack spacing={2} sx={{ p: 2 }}>
                <Stack spacing={0.5}>
                  <Typography sx={{ fontSize: "12px", color: "#666" }}>
                    Destination Site <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <input
                    style={{ ...inputStyle, width: "95%" }}
                    placeholder="DemoClient 001 - Central Lab"
                    value={destinationSite}
                    onChange={(e) => setDestinationSite(e.target.value)}
                  />
                </Stack>

                <Stack spacing={0.5}>
                  <Typography sx={{ fontSize: "12px", color: "#666" }}>
                    Shipping Address <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <textarea
                    style={{ ...inputStyle, width: "95%" }}
                    value={shippingAddress}
                    onChange={(e) => setShippingAddress(e.target.value)}
                    rows={2}
                    placeholder="Enter Address"
                  />
                </Stack>

                <Stack direction="row" sx={{ gap: "28px" }}>
                  <Stack flex={1}>
                    <Typography sx={labelStyle}>
                      Ship Date <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>
                    <input
                      type="date"
                      style={{ ...inputStyle, width: "90%" }}
                      value={shipDate}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => setShipDate(e.target.value)}
                    />
                  </Stack>

                  <Stack flex={1}>
                    <Typography sx={labelStyle}>
                      Ship Time <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>
                    <input
                      type="time"
                      style={{ ...inputStyle, width: "90%" }}
                      value={shipTime}
                      onChange={(e) => setShipTime(e.target.value)}
                    />
                  </Stack>
                </Stack>

                <Stack direction="row" spacing={2}>
                  <Stack flex={1}>
                    <Typography sx={labelStyle}>
                      Carrier <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      size="small"
                      value={carrier}
                      onChange={(e) => setCarrier(e.target.value)}
                      displayEmpty
                      sx={{
                        width: "100%",
                        "& .MuiSelect-select": {
                          color: carrier ? "#000" : "#676869",
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Carrier
                      </MenuItem>

                      {carrierTypes.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Stack>

                  <Stack flex={1}>
                    <Typography sx={labelStyle}>
                      Temperature <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>

                    <Select
                      size="small"
                      value={temperature}
                      onChange={(e) => setTemperature(e.target.value)}
                      displayEmpty
                      sx={{
                        width: "90%",
                        "& .MuiSelect-select": {
                          color: carrier ? "#000" : "#676869",
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Temperature
                      </MenuItem>

                      {temperatureOptions.map((temp, index) => (
                        <MenuItem key={index} value={temp}>
                          {temp}
                        </MenuItem>
                      ))}
                    </Select>
                  </Stack>
                </Stack>

                <Stack spacing={0.5}>
                  <Typography sx={labelStyle}>Special Instructions</Typography>
                  <textarea
                    style={{ ...inputStyle, width: "95%" }}
                    value={specialInstruction}
                    onChange={(e) => setSpecialInstruction(e.target.value)}
                    rows={3}
                    placeholder="Optional handling notes..."
                  />
                </Stack>
              </Stack>

              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  borderTop: "1px solid #eee",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  background: "#fafafa",
                }}
              >
                <button
                  style={{
                    ...draftBtn,
                    opacity: isFormValid ? 1 : 0.5,
                    cursor: isFormValid ? "pointer" : "not-allowed",
                    color: isFormValid ? "#000" : "#555",
                  }}
                  disabled={!isFormValid}
                  onClick={handleSaveDraft}
                >
                  SAVE DRAFT
                </button>

                <button
                  style={{
                    ...submitBtn,
                    opacity: isFormValid ? 1 : 0.5,
                    cursor: isFormValid ? "pointer" : "not-allowed",
                  }}
                  disabled={!isFormValid}
                  onClick={() => {
                    setActionType("Pending");
                    setOpenDialog(true);
                  }}
                >
                  SUBMIT REQUEST
                </button>
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>

      {showConfirmModal && (
        <Dialog
          open={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-description"
        >
          <Box sx={{ p: 3 }}>
            <Typography id="confirm-dialog-title" variant="h6" sx={{ mb: 2 }}>
              Confirm Selection
            </Typography>
            <Typography id="confirm-dialog-description" sx={{ mb: 3 }}>
              Are you sure you want to set default selected Client and
              Project(s)
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setShowConfirmModal(false)}
              >
                No
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSetDefault}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </Dialog>
      )}

      <ShipmentRequestConfirmationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        selectedRows={selectedRows}
        payload={{
          request_id: requestId,
          inventory_codes: requestInventoryCodes,
          client: selectedClients,
          project: selectedProjects,
          ship_date: shipDate,
          ship_time: shipTime,
          status: actionType,
          carrier: carrier,
          temprature: temperature,
          destination_site: destinationSite,
          shipping_address: shippingAddress,
          special_instruction: specialInstruction || "NA",
        }}
        onSuccess={(message) => {
          setOpenDialog(false);
          commonDispatch("success", message);
          getTableData();
          setSelectedRows([]);
          setShipDate("");
          setShipTime("");
          setCarrier("");
          setTemperature("");
          setDestinationSite("");
          setShippingAddress("");
          setSpecialInstruction("");
          setClientState("");
          setProjectState("");
          setProjectOptions([]);
        }}
      />
    </UIWrapper>
  );
};

export default ShipmentRequest;
